import { DialogCentered } from '../DialogCentered';
import { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import Typography from '@mui/material/Typography';
import { useChainId, useWalletClient } from 'wagmi';
import { ConnectWalletButton } from '../buttons/ConnectWalletButton';

export type ConnectWalletGuardProps = {
  title: string;
  open: boolean;
  onClose?: () => void;
};

export const ConnectWalletGuard = ({
  title,
  onClose = () => {
    /* */
  },
  open: openExternal,
}: ConnectWalletGuardProps) => {
  const [open, setOpen] = useState(openExternal);
  const { userData } = useAuth();
  const chainId = useChainId();
  const { data: walletClient } = useWalletClient({ chainId });
  useEffect(() => {
    const handler = async () => {
      const signerAddresses = await walletClient?.requestAddresses();
      const signerAddress = signerAddresses?.[0];
      if (userData?.addresses?.length && signerAddress) {
        onClose();
      }
    };
    handler();
  }, [userData?.addresses, onClose, walletClient]);

  return (
    <DialogCentered open={open} onClose={onClose}>
      <Typography variant="h5" sx={{ px: 4, pb: 4, fontWeight: '500' }}>
        {title}
      </Typography>
      <ConnectWalletButton
        fullWidth
        onClose={onClose}
        onClick={() => {
          setOpen(false);
        }}
        sx={{ mt: 4 }}
      />
    </DialogCentered>
  );
};

/* <Button
        onClick={() => {
          openAuthModal('pick wallet', onClose);
          setOpen(false);
        }}
        variant="contained"
        size="large"
        color="primary"
        fullWidth
        startIcon={<AccountBalanceWalletOutlined />}
        sx={{ mt: 4 }}
      >
        Connect Wallet
      </Button> */
